import './DateRangeSelector.css';
export var selector = '_1uftu980-3-5-0';